import React,  { Component } from 'react';
// import SimpleImageSlider from "react-simple-image-slider";
import { Slide, Fade, Zoom } from 'react-slideshow-image';

const properties = {
    duration: 5000,
    transitionDuration: 500,
    infinite: true,
    indicators: true,
    arrows: true,
    onChange: (oldIndex, newIndex) => {

    }
}
class MenuItemImageGallery extends Component {
    static getAspectRatio = () => {
      return {
        width: 300,
        height: 200,
      }
    }
    constructor(props) {
        super(props);
        this.state = { };
    }
    componentDidMount = () => {
      // We need a small delay here as 'react-slideshow-image' internally
      // uses domElement.clientWidth to calculate the width of <img>.
      // We need the Modal to fully render first, else the calculation
      // will fail and results in hardcoded "width: 0px"
      setTimeout(() => {
          this.setState({isReady: true})
      }, 500)
    }
    getMerchantMenuItemImage = () => {
      return this.props.menuItem && this.props.menuItem.getImageUrl()
    }
    render() {
      let images = this.props.menuItemImages.map(menuItemImage => menuItemImage.getImageUrl())
      const allowUseMerchantMenuItemImage = this.props.app.isMerchantHasFeature('use_merchant_menu_item_image_as_default_user_menu_item_image')
      const forceUseMerchantMenuItemImage = this.props.app.isMerchantHasFeature('force_use_merchant_menu_item_image_as_default_user_menu_item_image')

      if (images.length == 0 && ((!allowUseMerchantMenuItemImage && !forceUseMerchantMenuItemImage) || !this.getMerchantMenuItemImage())) {
        return <div></div>
      }
      else if (!this.state.isReady) {
          return <div style={{height: "230px"}}></div>
      }

      let isMerchantImage = false
      if (images.length == 0) {
        // Use merchant menu item image if no needed
        images = [this.getMerchantMenuItemImage()]
        isMerchantImage = true
      }

      return (
          <div className="slide-container" style={{height: "230px"}}>
            {
              this.state.isReady &&
              <Slide {...properties}>
                {
                  images.map((image,index) => {
                    return <div key={index} className="each-slide">
                      <div style={{
                        backgroundSize: "contain", backgroundPosition:"center  ",backgroundRepeat: "no-repeat",
                        backgroundImage: `url(${image})`}}>
                        {/* Overlay text here */}
                      </div>
                    </div>
                  })
                }
              </Slide>
            }
          </div>
      )
    }
}

export default MenuItemImageGallery;